import React from "react";
import { Flex, Icon, IconButton, Text } from "@chakra-ui/react";
import { chakraComponents } from "chakra-react-select";
import {
  IoCaretDownOutline,
  IoChevronBack,
  IoChevronForward
} from "react-icons/io5";
import Select from "../../../select";
import { MONTHS, getYears } from "./duck";

interface HeaderProps {
  date: Date;
  changeYear(year: number): void;
  decreaseMonth(): void;
  increaseMonth(): void;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  futureYears?: number;
}

const Header: React.FC<HeaderProps> = ({
  date,
  changeYear,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  futureYears
}) => {
  const [year, setYear] = React.useState<string>(date.getFullYear().toString());

  return (
    <>
      <Select
        isSearchable={false}
        isClearable={false}
        size="sm"
        inputLayoutProps={{ width: "fit-content", pt: 3, pl: 3, pb: "5px" }}
        chakraStyles={{
          valueContainer: provided => ({
            ...provided,
            fontSize: "sm",
            color: "dark.500",
            fontWeight: "bold",
            p: "0 0 0 6px"
          }),
          control: provided => ({
            ...provided,
            border: "none",
            _focusVisible: { backgroundColor: "gray.100", border: "none" },
            minHeight: 7,
            borderRadius: "6px",
            cursor: "pointer"
          }),
          dropdownIndicator: (provided, { selectProps }) => ({
            ...provided,
            mx: 0,
            color: "gray.700",
            fontSize: "12px",
            "> svg": {
              transform: `rotate(${selectProps.menuIsOpen ? -180 : 0}deg)`
            }
          }),
          menuList: provided => ({
            ...provided,
            py: 0,
            borderRadius: "8px",
            minW: "100px"
          })
        }}
        components={{
          DropdownIndicator: props => (
            <chakraComponents.DropdownIndicator {...props}>
              <Icon as={IoCaretDownOutline} />
            </chakraComponents.DropdownIndicator>
          )
        }}
        value={year}
        options={getYears(futureYears)}
        onChange={newYear => {
          if (newYear) {
            setYear(newYear);
            changeYear(+newYear);
          }
        }}
      />

      <Flex
        justify="space-between"
        align="center"
        pt={3}
        px={3}
        borderTop="1px solid #CBD5E0"
      >
        <Text fontWeight="bold" fontSize="sm" color="dark.500">
          {MONTHS[date.getMonth()]}
        </Text>

        <Flex columnGap={3} align="center">
          <IconButton
            minW={4}
            h={4}
            display="flex"
            onClick={decreaseMonth}
            aria-label="Previous month"
            icon={<Icon as={IoChevronBack} boxSize="16px" color="gray.700" />}
            variant="unstyled"
            disabled={prevMonthButtonDisabled}
          />
          <IconButton
            minW={4}
            h={4}
            display="flex"
            onClick={increaseMonth}
            aria-label="Next month"
            icon={
              <Icon as={IoChevronForward} boxSize="16px" color="gray.700" />
            }
            variant="unstyled"
            disabled={nextMonthButtonDisabled}
          />
        </Flex>
      </Flex>
    </>
  );
};

export default Header;
